import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';
import {PaymentObject} from '../../types/payments';

type EventPaymentFinishedData = {
    payment: PaymentObject
};

export class EventPaymentFinishedHandler {
    public handle(data: EventPaymentFinishedData): void {
        ClientEventEmitter.fireEvent(ClientEvents.PAYMENT_FINISHED, { paymentObject: data.payment });
    }
}
